import { computed, watch } from '@vue/composition-api';
import type { ComputedRef, Ref } from '@vue/composition-api';
import type {
  HokkaidoAirportSettings,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportSettings';

interface UseCarTypeChoicesResult {
  carTypes: ComputedRef<string[]>;
}

export const useCarTypeChoices = (
  userSettings: Ref<HokkaidoAirportSettings>,
  selection: { selectedAirport: string; selectedCarType: string },
): UseCarTypeChoicesResult => {
  const carTypes = computed<string[]>(() => {
    return userSettings.value.choices.car_types[selection.selectedAirport] ?? [];
  });

  // 空港を変えて車種が選択肢外になったら未選択に戻す
  watch(() => selection.selectedAirport, () => {
    if (carTypes.value.includes(selection.selectedCarType)) return;

    selection.selectedCarType = '';
  });

  return { carTypes };
};
